export default __webpack_public_path__ + "static/media/data-step-image-mobile.01577d5b.png";